import { Link2 } from 'lucide-react';
import { cn } from '../../lib/utils';

const SCOPE_STYLES = {
  block: {
    line: 'bg-primary/45',
    icon: 'text-primary/70',
  },
  phase: {
    line: 'bg-violet-500/45',
    icon: 'text-violet-500/75',
  },
};

export default function BlockCalendarScopeCell({ spanRole, bucket, children, title }) {
  const scoped = bucket === 'block' || bucket === 'phase';
  const styles = SCOPE_STYLES[bucket] || SCOPE_STYLES.block;
  const showConnector = scoped && spanRole && spanRole !== 'none';

  return (
    <div className='relative flex w-full min-h-[26px] items-center justify-center' title={title}>
      {showConnector ? (
        <>
          {(spanRole === 'start' || spanRole === 'middle' || spanRole === 'single') && (
            <span
              className={cn(
                'pointer-events-none absolute top-1/2 h-[2px] -translate-y-1/2',
                styles.line,
                spanRole === 'start' && 'left-[calc(50%-1px)] right-0',
                spanRole === 'middle' && 'left-0 right-0',
                spanRole === 'single' && 'left-[16%] right-[16%]'
              )}
              aria-hidden
            />
          )}
          {(spanRole === 'end' || spanRole === 'middle') && (
            <span
              className={cn(
                'pointer-events-none absolute top-1/2 left-0 h-[2px] -translate-y-1/2',
                styles.line,
                spanRole === 'end' && 'right-[calc(50%-1px)]',
                spanRole === 'middle' && 'right-0'
              )}
              aria-hidden
            />
          )}
          {(spanRole === 'start' || spanRole === 'single') && (
            <Link2
              className={cn(
                'pointer-events-none absolute left-0 top-1/2 h-2.5 w-2.5 -translate-y-1/2',
                styles.icon
              )}
              aria-hidden
            />
          )}
          {(spanRole === 'end' || spanRole === 'single') && (
            <Link2
              className={cn(
                'pointer-events-none absolute right-0 top-1/2 h-2.5 w-2.5 -translate-y-1/2',
                styles.icon
              )}
              aria-hidden
            />
          )}
        </>
      ) : null}
      <div className='relative z-[1]'>{children}</div>
    </div>
  );
}
